/**
 * Parses an `accessExpirationDate` string in "MM/DD/YYYY" format and returns
 * the Unix timestamp (ms) representing the END of that date in Pacific Time
 * (i.e. midnight PT of the following day).
 *
 * See backend/src/utils/parseAccessExpirationDate.ts for full background.
 *
 * @param dateStr "MM/DD/YYYY" formatted date from SC.Services
 * @returns Unix timestamp (ms) of midnight PT the day after `dateStr`
 */
export const parseAccessExpirationDate = (dateStr: string): number => {
  const parts = dateStr.split("/");
  if (parts.length !== 3) {
    return Date.parse(dateStr);
  }
  const [mm, dd, yyyy] = parts.map(Number);
  if (
    !Number.isFinite(mm) ||
    !Number.isFinite(dd) ||
    !Number.isFinite(yyyy)
  ) {
    return Date.parse(dateStr);
  }
  // Midnight PT of the day AFTER `dateStr` = next-day midnight UTC + 8h
  const PT_OFFSET_MS = 8 * 60 * 60 * 1000;
  return Date.UTC(yyyy, mm - 1, dd + 1) + PT_OFFSET_MS;
};
